import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppContextData } from '../../features/AppContext';
import {
  getBrandLogoSrc,
  getDefaultBrandLogo
} from '../../utilities/brandLogo';

/**
 * Shared auth-screen logo. Resolves CDN / override via getBrandLogoSrc.
 * Falls back to the bundled Zinier wordmark if the remote asset fails to load.
 */
export function BrandLogo ({ className, style, onClick, alt }) {
  const context = useContext(AppContextData);
  const orgId = context?.state?.org_id || context?.state?.org_alias || '';
  const resolvedSrc = getBrandLogoSrc(orgId);
  const [src, setSrc] = useState(resolvedSrc);

  useEffect(() => {
    setSrc(resolvedSrc);
  }, [resolvedSrc]);

  return (
    <img
      src={src}
      alt={alt || 'Zinier'}
      className={className}
      style={style}
      onClick={onClick}
      onError={() => {
        const fallback = getDefaultBrandLogo();
        if (src !== fallback) {
          setSrc(fallback);
        }
      }}
    />
  );
}

BrandLogo.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  alt: PropTypes.string
};

export default BrandLogo;
